import React from "react";
import PropTypes from "prop-types";
export function SectionIcon({ width = 24, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 25"
      enableBackground="new 0 0 25 25"
    >
      <g>
        <path d="m9.5 24h-8c-.827 0-1.5-.673-1.5-1.5v-21c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v21c0 .827-.673 1.5-1.5 1.5zm-8-23c-.276 0-.5.224-.5.5v21c0 .276.224.5.5.5h8c.276 0 .5-.224.5-.5v-21c0-.276-.224-.5-.5-.5z" />
      </g>
      <g>
        <path d="m22.5 6h-8c-.827 0-1.5-.673-1.5-1.5v-3c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm-8-5c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5h8c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5z" />
      </g>
      <g>
        <path d="m22.5 15h-8c-.827 0-1.5-.673-1.5-1.5v-3c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm-8-5c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5h8c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5z" />
      </g>
      <g>
        <path d="m22.5 24h-8c-.827 0-1.5-.673-1.5-1.5v-3c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm-8-5c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5h8c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5z" />
      </g>
    </svg>
  );
}

SectionIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};
